/**
 * Pairing links (Section 4, LOCKED pattern).
 *
 * A manager or an owner makes a one time code with the staff-login function.
 * The code travels as a link, /registrar?code=..., and the phone that opens it
 * exchanges it once for a device token. These helpers only build and read the
 * link. They never store the code anywhere.
 */

const CODE_SHAPE = /^[A-Za-z0-9_-]{20,128}$/;

/** The link a manager sends. The origin is whatever the app is served from. */
export function buildPairingLink(origin: string, code: string): string {
  return `${origin.replace(/\/+$/, '')}/registrar?code=${encodeURIComponent(code)}`;
}

/**
 * Reads a code out of whatever a person pastes: the whole link, a fragment of
 * it, or the bare code. Returns null when it does not look like a code, so a
 * typo never becomes a request to the server.
 */
export function parsePairingInput(input: string): string | null {
  const text = input.trim();
  if (!text) return null;

  const fromQuery = /[?&]code=([^&#\s]+)/.exec(text);
  const candidate = fromQuery ? safeDecode(fromQuery[1] ?? '') : text.replace(/\s+/g, '');
  return CODE_SHAPE.test(candidate) ? candidate : null;
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

/** A WhatsApp deep link with the pairing message pre filled. */
export function whatsappLink(text: string): string {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}
